import { useAtomValue } from 'jotai';
import { urlProfile } from '@/urls';
import { userAtom } from '@repo/api-client/stores/auth';

function Profile() {
  const user = useAtomValue(userAtom);

  return (
    <div className="mx-auto max-w-2xl space-y-16 p-8 sm:space-y-20 lg:mx-0 lg:max-w-none">
      <dl className="divide-y divide-gray-100 text-sm/6">
        <div className="py-6 sm:flex">
          <dt className="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6">Nombre</dt>
          <dd className="mt-1 flex justify-between gap-x-6 sm:mt-0 sm:flex-auto">
            <div className="text-gray-900">
              {user?.firstName} {user?.lastName}
            </div>
          </dd>
        </div>
        <div className="py-6 sm:flex">
          <dt className="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6">Email</dt>
          <dd className="mt-1 flex justify-between gap-x-6 sm:mt-0 sm:flex-auto">
            <div className="text-gray-900">{user?.email}</div>
          </dd>
        </div>
        <div className="py-6 sm:flex">
          <dt className="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6">
            Fecha de registro
          </dt>
          <dd className="mt-1 flex justify-between gap-x-6 sm:mt-0 sm:flex-auto">
            <div className="text-gray-900">
              {new Date(user?.createdAt || '').toLocaleDateString()}
            </div>
          </dd>
        </div>
      </dl>
    </div>
  );
}

export const route = {
  path: urlProfile(':id'),
  element: <Profile />,
  handle: {
    title: 'Perfil',
  },
};
